import { Locale, type LocalizedString } from "./Locale.js";

export enum Department {
	Backoffice = "Backoffice",
	Management = "Management",
	Sales = "Sales",
	Service = "Service",
	Software = "Software",
}

export const departmentNameMap: Record<Department, LocalizedString> = {
	[Department.Service]: {
		[Locale.cs]: "Servis a podpora",
		[Locale.en]: "Service and Support",
	},
	[Department.Sales]: {
		[Locale.cs]: "Prodej",
		[Locale.en]: "Sales",
	},
	[Department.Software]: {
		[Locale.cs]: "Software",
		[Locale.en]: "Software",
	},
	[Department.Backoffice]: {
		[Locale.cs]: "Backoffice",
		[Locale.en]: "Backoffice",
	},
	[Department.Management]: {
		[Locale.cs]: "Management",
		[Locale.en]: "Management",
	},
};
